module.exports = __webpack_public_path__ + "static/img/theme1.ba5397ba.png";